import { Tooltip as ChakraTooltip, TooltipProps } from "@chakra-ui/react";

export const Tooltip: React.FC<TooltipProps> = ({
	// color = "white",
	// bg = "gray.700",
	label,
	children,
	hasArrow = true,
	shouldWrapChildren = true,
	...props
}) => {
	// styles currently not working and don't want to burn too much time messing about with it right now
	// we have also had to add styles to index.css
	return (
		<ChakraTooltip
			label={""}
			// bg={bg}
			// color={color}
			hasArrow={true}
			shouldWrapChildren={shouldWrapChildren}
			className="!rounded-md !bg-gray-700 !px-3 !py-1 !font-sans !text-sm !text-white"
			{...props}
		>
			{children}
		</ChakraTooltip>
	);
};
